<template>
  <div>
    <v-row no-gutters class="text-body-2 font-weight-medium">
      <v-col cols="auto"> {{ contactDepartment }} </v-col>
    </v-row>
    <v-row no-gutters class="sidebar-contact-body mt-3" v-for="(contactData, idx) of contactDataList" :key="idx">
      <v-col cols="auto" class="pl-3">
        <v-row no-gutters class="pt-3 text-body-2 font-weight-medium">
          {{ contactData.name }}
        </v-row>
        <v-row no-gutters class="text-body-2">
          <span class="font-size-10" style="position: relative; top: -5px; color: rgba(0, 0, 0, 0.37)">
            {{ contactData.position }}
          </span>
        </v-row>
        <v-row no-gutters class="pt-1 text-body-2">
          <v-col cols="auto" class="pr-3"> <v-icon color="secondary"> mdi-email </v-icon> </v-col>
          <v-col cols="auto" class="font-size-12">
            {{ contactData.mail }}
          </v-col>
        </v-row>
        <v-row no-gutters class="pt-2 pb-3 text-body-2">
          <v-col cols="auto" class="pr-3"> <v-icon color="secondary"> mdi-phone </v-icon> </v-col>
          <v-col cols="auto" class="font-size-12">
            {{ contactData.phone }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { get } from 'vuex-pathify';
export default {
  name: 'SidebarContact',
  computed: {
    settingsValues: get('admin/settings'),
    contactDataList() {
      return [this.settingsValues['CONTACT_ONE_SETTING']?.value, this.settingsValues['CONTACT_TWO_SETTING']?.value];
    },
    contactDepartment() {
      return this.settingsValues['DEPARTMENT_SETTING']?.value;
    },
  },
};
</script>
<style lang="scss" scoped>
.sidebar-contact-body {
  background-color: #262e3e1a;
  border-left: 6px solid map-get($colors, 'secondary');
  border-radius: 6px !important;
  overflow: hidden;
}
</style>
